import { twMerge } from 'tailwind-merge';

import Image from '../Image';
import Link from '../Link';

interface Props {
  imageSrc?: string;
  imageAlt?: string;
  title: string;
  slug?: string;
  trackInfo?: Record<string, string | number>;
  imageWidth?: number;
  description?: string;
}

const Card = ({ imageSrc, imageAlt, title, slug, trackInfo, imageWidth, description }: Props) => {
  return (
    <Link
      className="shadow-m rounded-brand flex h-full flex-col overflow-hidden bg-white"
      data-card
      href={slug || ''}
      trackInfo={trackInfo}
    >
      <div className={twMerge('h-50 w-full flex-grow', imageSrc ? '' : 'rounded-brand rounded-b-none bg-red-900')}>
        {imageSrc && (
          <Image
            alt={imageAlt}
            className="rounded-brand h-full w-full rounded-b-none object-cover"
            src={imageSrc}
            width={imageWidth ?? 500}
          />
        )}
      </div>
      <div className="rounded-br-brand flex min-h-20 flex-col bg-white px-6 py-4">
        <div className="h4">{title}</div>
        {description && <div className="mt-2 text-sm text-gray-600">{description}</div>}
      </div>
    </Link>
  );
};

export default Card;
